import React, { useEffect, useState } from 'react';
import { Button, message, Steps, Form, Input, Card, Row, Col, Select, Checkbox } from 'antd';
import { FirmModel, BRANCH_OFFICES_DROPDOWN_OPTIONS, BRANCH_OFFCIES_YES, CORPORATE_STATUS_DROPDOWN_OPTIONS } from '../../models/firm';
import { lzNotifyErrorMessageFromResult, lzNotifySuccessMessage } from '../../helpers/commons/notifications';
import { wtApiCall } from '../../helpers/commons/ApiWrapper';
import { InboxOutlined } from '@ant-design/icons';
import { Upload } from 'antd';
import BaseListing from '../../../src/BaseListings'
import InputMask from 'react-input-mask';
const Base = new BaseListing()
const { Dragger } = Upload;
const steps = [
  {
    title: 'Business Details',
    content: 'Second-content',
  },
  {
    title: 'Personal Bio Data',
    content: 'First-content',
  },
  {
    title: 'Categories',
    content: 'Third-content',
  },
  {
    title: 'Documents',
    content: 'Third-content',
  },
  {
    title: 'Review And Submit',
    content: 'Last-content',
  },
];

const App = () => {
  const [current, setCurrent] = useState(0);
  const [form] = Form.useForm();
  const [model, setmodel] = useState(FirmModel);
  const [Categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]); // Track selected categories
  const [Cities, setCities] = useState([]); // Track selected categories
  const [Years, setYears] = useState([]); // Track selected categories

  const [isBranchOpen, setIsBranchOpen] = useState(false); // Track whether the branch offices are open

  const next = () => {
    form.validateFields()
      .then(() => setCurrent(current + 1))
      .catch((error) => console.log(error));
  };
  const prev = () => {
    setCurrent(current - 1);
  };

  const save = () => {

    form.validateFields()
      .then(() => {
        const formData = new FormData();
  
        formData.append("model", JSON.stringify(model));
      
        // Function to append files and log their details
        const appendFiles = (fileArray, fieldName) => {
          if (fileArray && fileArray.length > 0) {
            for (let i = 0; i < fileArray.length; i++) {
              formData.append(`${fieldName}[]`, fileArray[i]);
            }
            console.log(`${fileArray.length} files added for ${fieldName}.`);
          } else {
            console.log(`No files found for ${fieldName}.`);
          }
        };
      
        appendFiles(model.cnic, 'cnic');
        appendFiles(model.ntn, 'ntn');
        appendFiles(model.other_documents, 'other_documents');
        appendFiles(model.profile, 'profile');
      
        // Log formData contents (for debugging)
        for (let pair of formData.entries()) {
          if (pair[1] instanceof File) {
            console.log(`${pair[0]}: ${pair[1].name}`);
          } else {
            console.log(`${pair[0]}: ${pair[1]}`);
          }
        }
      
        // Proceed with the API call
        wtApiCall(
          'suppliers',
          formData,
          'post',
          (response) => {
            lzNotifySuccessMessage(response.data);
          },
          (error) => {
            lzNotifyErrorMessageFromResult(error.message);
          }
        );
      })
      .catch((error) => console.log('Validation Failed:', error));
   
  };
  
  

  const handleBeforeUpload = (key) => (file) => {
    setmodel((prev) => ({ ...prev, [key]: [file] }));
    message.success(`${file.name} file selected in ${key}.`);
    return false; // Prevent automatic upload
  };

  const handleRemove = (key) => (file) => {
    setmodel((prev) => ({
      ...prev,
      [key]: prev[key].filter((f) => f.uid !== file.uid),
    }));
    message.success(`${file.name} file removed from ${key}.`);
  };

  const uploaderProps = (key) => ({
    name: 'file',
    multiple: false,
    beforeUpload: handleBeforeUpload(key),
    onRemove: handleRemove(key),
    fileList: model[key],
  });

  const onFormChange = (changedValues, allValues) => {
    setmodel({ ...model, ...changedValues });
    if (changedValues.hasOwnProperty('branch_offices')) {
      if (changedValues.branch_offices === BRANCH_OFFCIES_YES) {
        setIsBranchOpen(true);
      } else {
        setIsBranchOpen(false);
      }
    }
  };

  const getData = () => {
    wtApiCall(
      'categories',
      { branch_id: 1 },
      'get',
      (response) => {
        setCategories(response.data.data);
      },
      (error) => {
        lzNotifyErrorMessageFromResult(error);
      },
    );
  };
  const handleCategoryChange = (checkedValues) => {
    const record = { ...model }
    record.categories = checkedValues
    setmodel(record)
  };
  useEffect(() => {
    Base.dropdownData(
      'cities,years',
      {},
      [setCities, setYears],
      1,
    )
    getData();
  }, []);
  const renderFormContent = () => {
    switch (current) {
      case 0:
        return (
          <>

            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  label={
                    <span style={{ fontWeight: 'bold' }}>
                      Business Name 
                    </span>
                  }
                  name="business_name"
                  style={{textAlign:'left'}}
                  rules={[{ required: true, message: 'Please enter your business name.' }]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label={
                    <span style={{ fontWeight: 'bold' }}>
                      NTN Number 
                    </span>
                  }

                  name="ntn_number"
                  style={{textAlign:'left'}}
                  rules={[{ required: true, message: 'Please enter your ntn number.' }]}

                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label={
                    <span style={{ fontWeight: 'bold' }}>
                      GST Number 
                    </span>
                  }
                  style={{textAlign:'left'}}
                  rules={[{ required: true, message: 'Please enter your gst number.' }]}
                  name="gst_number"
                >
                  <Input
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  label={
                    <span style={{ fontWeight: 'bold' }}>
                      Business Address 
                    </span>
                  }
                  style={{textAlign:'left'}}
                  rules={[{ required: true, message: 'Please enter your business address.' }]}
                  name="business_address"
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label={
                    <span style={{ fontWeight: 'bold' }}>
                      City 
                    </span>
                  }
                  style={{textAlign:'left'}}
                  rules={[{ required: true, message: 'Please select city name.' }]}
                  name="city_id"
                >
                  <Select
                    showSearch
                    placeholder="Select a City"
                    optionFilterProp="label"
                    style={{ textAlign: 'left' }}
                    options={Cities}
                  />

                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label={
                    <span style={{ fontWeight: 'bold' }}>
                      Email Address 
                    </span>
                  }
                  style={{textAlign:'left'}}
                  rules={[{ required: true, message: 'Please enter your email address.' }]}
                  name="email_address"
                >
                  <Input />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  label={<span style={{ fontWeight: 'bold' }}>Mobile No</span>}
                  style={{textAlign:'left'}}
                  rules={[{ required: true, message: 'Please enter mobile number.' }]}
                  name="mobile_no"
                >
                  <Input
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label={<span style={{ fontWeight: 'bold' }}>Alternate Mobile</span>}
                  name="alternate_no"
                >
                  <Input
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  label={<span style={{ fontWeight: 'bold' }}>Phone No (Office)</span>}
                  name="phone_no"
                >
                  <Input
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  label={<span style={{ fontWeight: 'bold' }}>Fax No (Office)</span>}
                  name="fax_no"
                >
                  <Input
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label={
                    <span style={{ fontWeight: 'bold' }}>Corporate Status 
                    </span>
                  }
                  style={{textAlign:'left'}}
                  rules={[{ required: true, message: 'Please select corporate status.' }]}
                  name="corporate_status"
                >
                  <Select
                    placeholder="Select Option"
                    options={CORPORATE_STATUS_DROPDOWN_OPTIONS}
                    style={{ textAlign: 'left' }}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label={
                    <span style={{ fontWeight: 'bold' }}>
                      Branch Offices 
                    </span>
                  }
                  style={{textAlign:'left'}}
                  rules={[{ required: true, message: 'Please select branch officer.' }]}
                  name="branch_offices"
                >
                  <Select
                    placeholder="Select Branch Offices"
                    options={BRANCH_OFFICES_DROPDOWN_OPTIONS}
                    style={{ textAlign: 'left' }}
                  />
                </Form.Item>
              </Col>
            </Row>

            {isBranchOpen && ( // Conditionally render branch address fields
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    label={<span style={{ fontWeight: 'bold' }}>Branch 1 Address </span>}
                    name="branch_one_address"
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label={<span style={{ fontWeight: 'bold' }}>Branch 2 Address</span>}
                    name="branch_two_address"
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label={<span style={{ fontWeight: 'bold' }}>Branch 3 Address</span>}
                    name="branch_three_address"
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            )}
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  label={<span style={{ fontWeight: 'bold' }}>Established in Year </span>}
                  style={{textAlign:'left'}}
                  rules={[{ required: true, message: 'Please select established year.' }]}
                  name="established_year"
                >
                  <Select
                    showSearch
                    placeholder="Select a year"
                    optionFilterProp="label"
                    options={Years}
                    style={{ textAlign: 'left' }}

                  />

                </Form.Item>
              </Col>
            </Row>
          </>

        );
      case 1:
        return (

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                label={
                  <span style={{ fontWeight: 'bold' }}>
                    Name of Applicant 
                  </span>
                }
                style={{textAlign:'left'}}
                rules={[{ required: true, message: 'Please enter applicant name.' }]}
                name="applicant_name"
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
            
                label={
                  <span style={{ fontWeight: 'bold' }}>
                    CNIC No
                  </span>
                }
                style={{textAlign:'left'}}
                rules={[{ required: true, message: 'Please enter cnic no.' }]}
                name="cnic_no"
              >
                <InputMask
                  mask="99999-9999999-9"
                  maskChar={null}
                  placeholder="XXXXX-XXXXXXX-X"
                  maxLength={15}
                >
                  {(inputProps) => <Input {...inputProps} />}
                </InputMask>
              </Form.Item>
            </Col>
          </Row>

        );
      case 2:
        return (

          <div style={{ textAlign: 'left', margin: '4px' }}>
            <Checkbox.Group
              style={{ fontWeight: 'bold' }}
              options={Categories.map(category => ({
                label: category.name,
                value: category.id
              }))}
              onChange={handleCategoryChange}
            />
          </div>

        );

      case 3:
        return (
          <>
            <Row gutter={16}>
              <Col span={12} style={{ textAlign: 'left' }}>
                {/* <label style={{ fontWeight: 'bold', textAlign: 'left' }}>CNIC Copy</label>. */}
                <Dragger {...uploaderProps('cnic')}>
                  <p className="ant-upload-text">Cnic Copy</p>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">Click or drag file to this area to upload</p>
                </Dragger>
              </Col>
              <Col span={12} style={{ textAlign: 'left' }}>
                {/* <label style={{ fontWeight: 'bold', textAlign: 'left' }}>NTN Number</label> */}
                <Dragger {...uploaderProps('ntn')}>
                  <p className="ant-upload-text">NTN Number</p>

                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">Click or drag file to this area to upload</p>
                </Dragger>
              </Col>
            </Row>
            <br />
            <br />
            <br />

            <Row gutter={16}>
              <Col span={12} style={{ textAlign: 'left' }}>
                {/* <label style={{ fontWeight: 'bold', textAlign: 'left' }}>Componay Profile</label> */}
                <Dragger {...uploaderProps('profile')}>
                  <p className="ant-upload-text">Company Profile</p>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">Click or drag file to this area to upload</p>
                </Dragger>
              </Col>
              <Col span={12} style={{ textAlign: 'left' }}>
                {/* <label style={{ fontWeight: 'bold', textAlign: 'left' }}>Other Documents</label> */}
                <Dragger {...uploaderProps('other_documents')}>
                  <p className="ant-upload-text">Other Documents</p>

                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">Click or drag file to this area to upload</p>
                </Dragger>
              </Col>
            </Row>
            <br />
            <br />

          </>
        );
      case 4:
        return (
          <>
            <Card title="Review Your Information" style={{ marginBottom: '20px' }}>
              <h4 style={{ textAlign: 'left', color: 'blue', }}><u>Business Details</u></h4>

              <Row gutter={16}>
                <Col span={8} style={{ textAlign: 'left' }}>
                  <p><strong>Business Name : </strong> {model.business_name}</p>
                </Col>
                <Col span={8} style={{ textAlign: 'left' }}>
                  <p><strong>NTN Number : </strong> {model.ntn_number}</p>
                </Col>
                <Col span={8} style={{ textAlign: 'left' }}>
                  <p><strong>GST Number : </strong> {model.gst_number}</p>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={8} style={{ textAlign: 'left' }}>
                  <p><strong>Business Address :</strong> {model.business_address}</p>
                </Col>
                <Col span={8} style={{ textAlign: 'left' }}>
                  <p><strong>City :</strong> {Cities.find(city_id => city_id.value === model.city_id)?.label}</p>
                </Col>
                <Col span={8} style={{ textAlign: 'left' }}>
                  <p><strong>Email Address :</strong> {model.email_address}</p>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={8} style={{ textAlign: 'left' }}>
                  <p><strong>Mobile No:</strong> {model.mobile_no}</p>
                </Col>
                <Col span={8} style={{ textAlign: 'left' }}>
                  <p><strong>Alternate No :</strong> {model.alternate_no ? model.alternate_no : '-'}</p>
                </Col>
                <Col span={8} style={{ textAlign: 'left' }}>
                  <p><strong>Phone No (Office) :</strong> {model.phone_no ? model.phone_no : '-'}</p>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={8} style={{ textAlign: 'left' }}>
                  <p><strong>Fax No (Office) :</strong> {model.fax_no ? model.fax_no : '-'}</p>
                </Col>
                <Col span={8} style={{ textAlign: 'left' }}>
                  <p><strong>Corporate Status:</strong> {CORPORATE_STATUS_DROPDOWN_OPTIONS.find(option => option.value === model.corporate_status)?.label}</p>
                </Col>
                <Col span={8} style={{ textAlign: 'left' }}>
                  <p><strong>Branch Offices:</strong> {BRANCH_OFFICES_DROPDOWN_OPTIONS.find(option => option.value === model.branch_offices)?.label}</p>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={8} style={{ textAlign: 'left' }}>
                  <p><strong>Branch 1 Address:</strong> {model.branch_one_address}</p>
                </Col>
                <Col span={8} style={{ textAlign: 'left' }}>
                  <p><strong>Branch 2 Address:</strong> {model.branch_two_address}</p>
                </Col>
                <Col span={8} style={{ textAlign: 'left' }}>
                  <p><strong>Branch 3 Address:</strong> {model.branch_three_address}</p>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={8} style={{ textAlign: 'left' }}>
                  <p><strong>Established in Year:</strong> {model.established_year}</p>
                </Col>
              </Row>

              <h4 style={{ textAlign: 'left', color: 'blue' }}><u>Personal Bio Data</u></h4>
              <Row gutter={16}>
                <Col span={8} style={{ textAlign: 'left' }}>
                  <p><strong>Name of Applicant : </strong> {model.applicant_name}</p>
                </Col>
                <Col span={8} style={{ textAlign: 'left' }}>
                  <p><strong>CNIC No : </strong> {model.cnic_no}</p>
                </Col>
                <Col span={8} style={{ textAlign: 'left' }}>
                </Col>
              </Row>

              <h4 style={{ textAlign: 'left', color: 'blue' }}><u>Categories</u></h4>
              <ul style={{ display: 'flex', justifyContent: 'flex-start', gap: '15px', listStyle: 'none', padding: 0 }}>
                {model.categories.map((id, index) => {
                  const category = Categories.find((cat) => cat.id === id);
                  return category ? (
                    <li key={id}>
                      <b>{index + 1}.</b> {category.name}
                    </li>
                  ) : null;
                })}



              </ul>

              <h4 style={{ textAlign: 'left', color: 'blue' }}><u>Uploaded Documents</u></h4>

              {model.cnic && model.cnic.length > 0 && (
                <p style={{ textAlign: 'left' }}><strong>CNIC Copy : </strong> {model.cnic[0].name}</p>
              )}
              {model.ntn && model.ntn.length > 0 && (
                <p style={{ textAlign: 'left' }}><strong>NTN Number : </strong> {model.ntn[0].name}</p>
              )}
              {model.profile && model.profile.length > 0 && (
                <p style={{ textAlign: 'left' }}><strong>Profile : </strong> {model.profile[0].name}</p>
              )}
              {model.other_documents && model.other_documents.length > 0 && (
                <p style={{ textAlign: 'left' }}><strong>Other Document : </strong> {model.other_documents[0].name}</p>
              )}
            </Card >
          </>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Card style={{ textAlign: 'center', }}  title={<h2 style={{ fontSize: '24px' }}>Supplier Registration</h2>} className="container mt-5">
        <br />
        <br />
        <Steps current={current}>
          {steps.map((item) => (
            <Steps.Step key={item.title} title={item.title} />
          ))}
        </Steps>
        <hr />
        <br />
        <div style={{ marginTop: 16 }}>
          <Form form={form} layout="vertical" onValuesChange={onFormChange} onSub>
            {renderFormContent()}
          </Form>
        </div>
        <div style={{ marginTop: 24 }}>
          {current < steps.length - 1 && (
            <Button style={{ float: 'right', margin: '4px' }} type="primary" onClick={next}>
              Next
            </Button>
          )}
          {current === steps.length - 1 && (
            <Button style={{ float: 'right', margin: '4px' }} type="primary" onClick={save}>
              Submit
            </Button>
          )}
          {current > 0 && (
            <Button style={{ marginLeft: 8, float: 'right', margin: '4px' }} onClick={prev}>
              Previous
            </Button>
          )}
        </div>
      </Card>
    </>
  );
};

export default App;
